import { Toast, ToastTitle, ToastDescription } from './ui/toast'
import { useToast } from '../contexts/ToastContext'

export function ToastContainer() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex max-h-screen w-full flex-col-reverse p-4 sm:left-auto sm:right-0 sm:bottom-0 sm:top-auto sm:flex-col sm:max-w-[420px]">
      <div className="w-full space-y-2 sm:space-y-2">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            variant={toast.variant}
            onClose={() => dismiss(toast.id)}
            className="w-full animate-in slide-in-from-bottom-5 sm:slide-in-from-right-5 duration-300"
          >
            {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
            {toast.description && (
              <ToastDescription>{toast.description}</ToastDescription>
            )}
          </Toast>
        ))}
      </div>
    </div>
  )
}